export default __webpack_public_path__ + "static/media/1.ac15c0ea.jpg";